var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac-view"},[_c('HeaderView',{attrs:{"title":_vm.title,"isLeft":true}}),_c('div',{staticClass:"ac-info"},[_c('van-image',{attrs:{"width":"100%","src":this.photo,"lazy-load":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }